var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.99999 0.504823L15.0121 7.51697L13.3622 9.16688L7.99999 3.80465L2.63776 9.16688L0.987845 7.51696L7.99999 0.504823Z","key":0}),React.createElement("path",{"d":"M7.99999 6.83355L15.0121 13.8457L13.3622 15.4956L7.99999 10.1334L2.63776 15.4956L0.987845 13.8457L7.99999 6.83355Z","key":1})]);
}

ArrowUp.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
